<section class="panel">
  <ng-content></ng-content>
</section>
